import type { Api, Vehicle } from '@cruz-com/lookup'
import { encodeQuery } from '@/lib'
import { baseURL, formatFetchError, getHeader } from '../util'

export async function savedVehicles(params: object): Promise<Api.Result<Vehicle.Summary[]>> {
  try {
    const res = await fetch(`${baseURL}/cruz/saved-vehicles?${encodeQuery(params)}`, {
      method: 'GET',
      headers: await getHeader(),
      cache: 'no-store',
    })
    const d = await res.json()
    if (!res.ok) {
      return Promise.reject(d)
    }
    return Promise.resolve(d)
  } catch (err) {
    return Promise.reject(formatFetchError(err))
  }
}
